import React, { useEffect } from "react";
import styled, { keyframes } from "styled-components";
import chokwinLoadingBack from "../../layouts/assets/images/chokwin_loading_back.webp";
import chokwinLoadingUp from "../../layouts/assets/images/chokwin_loading_up.webp";

const moveBall = keyframes`
	0% { 
		left: 0;
		transform: translateY(-50%) scale(1);
	}
	25% {
		transform: translateY(-50%) scale(1.1);
	}
	50% { 
		left: calc(100% - 20px);
		transform: translateY(-50%) scale(1);
	}
	75% {
		transform: translateY(-50%) scale(1.1);
	}
	100% { 
		left: 0;
		transform: translateY(-50%) scale(1);
	}
`;

const CHOKWIN_EXPANDED_LOADING = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-image: url(${chokwinLoadingBack});
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
	background-color: #000;
	z-index: 9999;

	.loading-content {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}

	.loading-image {
		display: block;
		margin-bottom: 20px;
		margin-right: -29.6px;
	}

	.loading-bar-container {
		width: 160px;
		height: 7px;
		background-color: #030507;
		border-radius: 6px;
		border: 0.6px solid #a0f592;
		overflow: hidden;
		position: relative;
	}

	.loading-bar-progress {
		width: 20px;
		height: 20px;
		background: #7ae767;
		border-radius: 50%;
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
		animation: ${moveBall} 1.5s infinite cubic-bezier(0.4, 0, 0.2, 1);
		box-shadow: 0 0 10px rgba(122, 231, 103, 0.5);
		will-change: transform, left;
	}
`;

const ChokwinLoading = () => {
	useEffect(() => {
		document.body.style.overflow = "hidden";
		return () => {
			document.body.style.overflow = "auto";
		};
	}, []);

	return (
		<CHOKWIN_EXPANDED_LOADING>
			<div className="loading-content">
				<img
					className="loading-image"
					src={chokwinLoadingUp}
					alt="Chokwin Loading"
				/>
				<div className="loading-bar-container">
					<div className="loading-bar-progress" />
				</div>
			</div>
		</CHOKWIN_EXPANDED_LOADING>
	);
};

export default ChokwinLoading;
